import {
    isCacheServiceLoaded,
    isCacheServiceLoading,
    loadCacheService,
    getServicesById,
    getCategoriesById,
    getServicesForSelect,
    getCategoriesForSelect,
    getCategoriesWithOptForSelect,
    onChangeInServices,
} from "./service";

import {
    isCacheSpecializationLoaded,
    isCacheSpecializationLoading,
    loadCacheSpecialization,
    getSpecializationsById,
    getSpecializationsForSelect,
    onChangeInSpecializations,
} from "./specialization";

import {
    isCacheUnitLoaded,
    isCacheUnitLoading,
    loadCacheUnit,
    getUnitsById,
    getUnitsForSelect,
    getUnitsIgnoreMTForSelect,
    onChangeInUnits,
} from "./unit";

import { isCacheTagLoaded, isCacheTagLoading, loadCacheTag } from "./tag";

import { isCachePriorityLoaded, isCachePriorityLoading, loadCachePriority } from "./priority";

import {
    isCacheCountryLoaded,
    isCacheCountryLoading,
    loadCacheCountry,
    getCountriesById,
    getCountriesForSelect,
    onChangeInCountries,
} from "./country";

import {
    isCacheCurrencyLoaded,
    isCacheCurrencyLoading,
    loadCacheCurrency,
    getCurrenciesById,
    getCurrenciesForSelect,
    onChangeInCurrencies,
} from "./currency";

import {
    isCacheLanguageLoaded,
    isCacheLanguageLoading,
    loadCacheLanguage,
    getLanguagesById,
    getLanguagesForSelect,
    onChangeInLanguages,
} from "./language";

import {
    isCacheLanguagePairLoaded,
    isCacheLanguagePairLoading,
    loadCacheLanguagePair,
    getLanguagePairsById,
    getLanguagePairsForSelect,
    onChangeInLanguagePairs,
} from "./languagePair";

import {
    isCacheVendorLoaded,
    isCacheVendorLoading,
    loadCacheVendor,
    getVendorsById,
    getVendorsForSelect,
} from "./vendor";

import {
    isCacheClientLoaded,
    isCacheClientLoading,
    loadCacheClient,
    getClientsById,
    getClientsForSelect,
} from "./client";

import {
    isCacheManagerLoaded,
    isCacheManagerLoading,
    loadCacheManager,
    getManagersById,
    getManagersForSelect,
} from "./manager";

//
import {
    isCacheCampaignLoaded,
    isCacheCampaignLoading,
    loadCacheCampaign,
    getCampaignsById,
    getCampaignsForSelect,
} from "./campaign";

import {
    isCacheCatlogLoaded,
    isCacheCatlogLoading,
    loadCacheCatlog,
    getCatlogsById,
    getCatlogsForSelect,
    getCatlogValueById,
    getCatlogValueNameById,
} from "./catlog";

export const CACHE_SERVICE = "service";
export const CACHE_SPECIALIZATION = "specialization";
export const CACHE_UNIT = "unit";
export const CACHE_COUNTRY = "country";
export const CACHE_CURRENCY = "currency";
export const CACHE_LANGUAGE = "language";
export const CACHE_LANGUAGE_PAIR = "languagePair";
export const CACHE_CAMPAIGN = "campaign";
export const CACHE_CATLOG = "catlog";
export const CACHE_VENDOR = "vendor";
export const CACHE_CLIENT = "client";
export const CACHE_MANAGER = "manager";
export const CACHE_TAG = "tag";
export const CACHE_PRIORITY = "priority";

export const isCacheLoading = (state, list = []) => {
    if (list.includes(CACHE_SERVICE) && isCacheServiceLoading(state)) {
        return true;
    }

    if (list.includes(CACHE_SPECIALIZATION) && isCacheSpecializationLoading(state)) {
        return true;
    }

    if (list.includes(CACHE_UNIT) && isCacheUnitLoading(state)) {
        return true;
    }

    if (list.includes(CACHE_COUNTRY) && isCacheCountryLoading(state)) {
        return true;
    }

    if (list.includes(CACHE_CURRENCY) && isCacheCurrencyLoading(state)) {
        return true;
    }

    if (list.includes(CACHE_LANGUAGE) && isCacheLanguageLoading(state)) {
        return true;
    }

    if (list.includes(CACHE_LANGUAGE_PAIR) && isCacheLanguagePairLoading(state)) {
        return true;
    }

    if (list.includes(CACHE_CAMPAIGN) && isCacheCampaignLoading(state)) {
        return true;
    }

    if (list.includes(CACHE_CATLOG) && isCacheCatlogLoading(state)) {
        return true;
    }

    if (list.includes(CACHE_VENDOR) && isCacheVendorLoading(state)) {
        return true;
    }

    if (list.includes(CACHE_CLIENT) && isCacheClientLoading(state)) {
        return true;
    }

    if (list.includes(CACHE_MANAGER) && isCacheManagerLoading(state)) {
        return true;
    }

    if (list.includes(CACHE_TAG) && isCacheTagLoading(state)) {
        return true;
    }

    if (list.includes(CACHE_PRIORITY) && isCachePriorityLoading(state)) {
        return true;
    }

    return false;
};

export const isCacheLoaded = (state, list = []) => {
    if (list.includes(CACHE_SERVICE) && !isCacheServiceLoaded(state)) {
        return false;
    }

    if (list.includes(CACHE_SPECIALIZATION) && !isCacheSpecializationLoaded(state)) {
        return false;
    }

    if (list.includes(CACHE_UNIT) && !isCacheUnitLoaded(state)) {
        return false;
    }

    if (list.includes(CACHE_COUNTRY) && !isCacheCountryLoaded(state)) {
        return false;
    }

    if (list.includes(CACHE_CURRENCY) && !isCacheCurrencyLoaded(state)) {
        return false;
    }

    if (list.includes(CACHE_LANGUAGE) && !isCacheLanguageLoaded(state)) {
        return false;
    }

    if (list.includes(CACHE_LANGUAGE_PAIR) && !isCacheLanguagePairLoaded(state)) {
        return false;
    }

    if (list.includes(CACHE_CAMPAIGN) && !isCacheCampaignLoaded(state)) {
        return false;
    }

    if (list.includes(CACHE_CATLOG) && !isCacheCatlogLoaded(state)) {
        return false;
    }

    if (list.includes(CACHE_VENDOR) && !isCacheVendorLoaded(state)) {
        return false;
    }

    if (list.includes(CACHE_CLIENT) && !isCacheClientLoaded(state)) {
        return false;
    }

    if (list.includes(CACHE_MANAGER) && !isCacheManagerLoaded(state)) {
        return false;
    }

    if (list.includes(CACHE_TAG) && !isCacheTagLoaded(state)) {
        return false;
    }

    if (list.includes(CACHE_PRIORITY) && !isCachePriorityLoaded(state)) {
        return false;
    }

    return true;
};

export const loadCache = (list = []) => (dispatch) => {
    if (list.includes(CACHE_SERVICE)) {
        dispatch(loadCacheService());
    }

    if (list.includes(CACHE_SPECIALIZATION)) {
        dispatch(loadCacheSpecialization());
    }

    if (list.includes(CACHE_UNIT)) {
        dispatch(loadCacheUnit());
    }

    if (list.includes(CACHE_COUNTRY)) {
        dispatch(loadCacheCountry());
    }

    if (list.includes(CACHE_CURRENCY)) {
        dispatch(loadCacheCurrency());
    }

    if (list.includes(CACHE_LANGUAGE)) {
        dispatch(loadCacheLanguage());
    }

    if (list.includes(CACHE_LANGUAGE_PAIR)) {
        dispatch(loadCacheLanguagePair());
    }

    if (list.includes(CACHE_CAMPAIGN)) {
        dispatch(loadCacheCampaign());
    }

    if (list.includes(CACHE_CATLOG)) {
        dispatch(loadCacheCatlog());
    }

    if (list.includes(CACHE_VENDOR)) {
        dispatch(loadCacheVendor());
    }

    if (list.includes(CACHE_CLIENT)) {
        dispatch(loadCacheClient());
    }

    if (list.includes(CACHE_MANAGER)) {
        dispatch(loadCacheManager());
    }

    if (list.includes(CACHE_TAG)) {
        dispatch(loadCacheTag());
    }

    if (list.includes(CACHE_PRIORITY)) {
        dispatch(loadCachePriority());
    }
};

export {
    getUnitsById,
    getUnitsForSelect,
    getUnitsIgnoreMTForSelect,
    onChangeInUnits,
    getServicesById,
    getCategoriesById,
    getServicesForSelect,
    getCategoriesForSelect,
    getCategoriesWithOptForSelect,
    onChangeInServices,
    getSpecializationsById,
    getSpecializationsForSelect,
    onChangeInSpecializations,
    getCountriesById,
    getCountriesForSelect,
    onChangeInCountries,
    getCurrenciesById,
    getCurrenciesForSelect,
    onChangeInCurrencies,
    getLanguagesById,
    getLanguagesForSelect,
    onChangeInLanguages,
    getLanguagePairsById,
    getLanguagePairsForSelect,
    onChangeInLanguagePairs,
    getCampaignsById,
    getCampaignsForSelect,
    getCatlogsById,
    getCatlogsForSelect,
    getCatlogValueById,
    getCatlogValueNameById,
    getVendorsById,
    getVendorsForSelect,
    getClientsById,
    getClientsForSelect,
    getManagersById,
    getManagersForSelect,
};
